/**
 * Created by ok on 5/10/16.
 */
import {ERROR_MESSAGE_RESETTED} from '../actions/actionTypes.js';
import merge from 'lodash/merge';
import union from 'lodash/union';
import {stringify, extract, parse} from 'query-string';

// Updates an entity cache in response to any action with response.entities.
export const updateEntityItemsCache = ( state, action, entityIdentifier ) => ({
    isFetching   : false,
    didInvalidate: false,
    items        : mergeItems( state.items, action, entityIdentifier ),
    entities     : mergeEntities( state.entities, action, entityIdentifier ),
    lastFetched  : action.fetchedAt
});

// Updates an entity cache in response to any action with response.entities.
export const updateEntityCache = ( state, action, entityIdentifier ) => ({
    isFetching   : false,
    didInvalidate: false,
    items        : action.response.result[entityIdentifier],
    entities     : mergeEntities( state.entities, action, entityIdentifier ),
    lastFetched  : action.fetchedAt
});

const mergeItems = ( items, action, entityIdentifier ) => {
    if ( action.response && action.response.result ) {
        return union( items, action.response.result[entityIdentifier] );
    }
};

const mergeEntities = ( entities, action, entityIdentifier ) => {
    if ( action.response && action.response.entities ) {
        return merge( {}, entities, action.response.entities[entityIdentifier] )
    }
};

//Updates error message to notify about the failed fetches.
export function errorMessage( action ) {
    const {type, error} = action;

    if ( type === ERROR_MESSAGE_RESETTED ) {
        return null;
    } else if ( error ) {
        return error;
    }
    return null;
}

const mergeDesignerItems = ( items, action ) => {
    let newItems = [];
    if ( action.response && ((action.response || {}).result || {}).result === "SUCCESS" && ((action.response || {}).result || {}).totalHits > 0) {
        newItems = Object.keys(action.response.entities["designer"]);
        return union( items, newItems );
    }
};

// Updates an entity cache in response to any action with response.entities.
export const updateDesignerEntityCache = ( state, action ) => ({
    isFetching   : false,
    didInvalidate: false,
    items        : mergeDesignerItems(state.items, action),
    entities     : mergeEntities( state.entities, action, "designer" ),
    lastFetched  : action.fetchedAt
});





// WEBPACK FOOTER //
// ./src/helper/entityReducer.js